import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Menu, Zap, LogOut, LayoutDashboard, Bot } from "lucide-react";

export function Logo() {
  return (
    <Link to="/" className="flex items-center gap-2 group" data-testid="nav-logo">
      <div className="w-9 h-9 rounded-xl bg-violet-600 flex items-center justify-center border-2 border-[#111114] group-hover:rotate-6 transition-transform">
        <Zap className="w-5 h-5 text-white" fill="white" />
      </div>
      <span className="font-display font-extrabold text-lg tracking-tight text-[#111114]">
        VangTech <span className="text-violet-600">Subs</span>
      </span>
    </Link>
  );
}

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const dashLink = user?.role === "creator" ? "/creator" : "/member";

  const Actions = ({ mobile }) => (
    <div className={mobile ? "flex flex-col gap-3 mt-8" : "hidden md:flex items-center gap-3"}>
      <Button variant="ghost" className="text-[#111114] hover:bg-indigo-50 font-semibold" onClick={() => navigate("/discord-bot")} data-testid="nav-discord-bot-btn">
        <Bot className="w-4 h-4 mr-2" /> Discord Bot
        <span className="ml-2 text-[10px] font-bold uppercase bg-indigo-100 text-indigo-700 rounded-full px-2 py-0.5 border border-indigo-200">Soon</span>
      </Button>
      {user ? (
        <>
          <Button variant="ghost" className="text-[#111114] hover:bg-violet-50 font-semibold" onClick={() => navigate(dashLink)} data-testid="nav-dashboard-btn">
            <LayoutDashboard className="w-4 h-4 mr-2" /> Dashboard
          </Button>
          <Button className="bg-white text-[#111114] btn-pop font-semibold rounded-full hover:bg-rose-50" onClick={logout} data-testid="nav-logout-btn">
            <LogOut className="w-4 h-4 mr-2" /> Log out
          </Button>
        </>
      ) : (
        <>
          <Button variant="ghost" className="text-[#111114] hover:bg-violet-50 font-semibold" onClick={() => navigate("/auth")} data-testid="nav-login-btn">
            Log in
          </Button>
          <Button className="bg-violet-600 hover:bg-violet-500 text-white btn-pop font-semibold rounded-full" onClick={() => navigate("/auth?role=creator")} data-testid="nav-signup-btn">
            Start free
          </Button>
        </>
      )}
    </div>
  );

  return (
    <header className="sticky top-0 z-50 bg-[#FAF9F6]/85 backdrop-blur-md border-b-2 border-[#111114]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Logo />
        <Actions />
        <div className="md:hidden">
          <Sheet>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" className="text-[#111114]" data-testid="nav-mobile-menu">
                <Menu className="w-6 h-6" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="bg-[#FAF9F6] border-l-2 border-[#111114]">
              <Actions mobile />
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}
